module.exports = __webpack_public_path__ + "img/touch-hint.75316fc1.svg";